import {JsonApiResponse} from '@tisa-group/cdk';
import {UmpireCompetition} from '@tisa-group/models';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {LoadCompetitions} from '@store/competitions/competitions.actions';
import {CompetitionService} from '@tisa-group/core';

export type CompetitionsStateModel = JsonApiResponse<UmpireCompetition[]>;
const ekstraklasaCompetitionName = 'ekstraklasa';

@State<CompetitionsStateModel>({
  name: 'competitions',
  defaults: {
    data: [],
  },
})
@Injectable()
export class CompetitionsState {
  @Action(LoadCompetitions)
  loadCompetitions(
    ctx: StateContext<CompetitionsStateModel>,
    action: LoadCompetitions,
  ):
    | Observable<JsonApiResponse<UmpireCompetition[]>>
    | JsonApiResponse<UmpireCompetition[]> {
    if (ctx.getState().data.length) {
      return ctx.getState();
    }

    return this.competitionService
      .list(action.params)
      .pipe(tap(res => ctx.setState(res)));
  }

  @Selector()
  static getEkstraklasaCompetition(
    state: CompetitionsStateModel,
  ): UmpireCompetition | undefined {
    return state.data.find(
      competition => competition.name?.toLowerCase() === ekstraklasaCompetitionName,
    );
  }

  constructor(readonly competitionService: CompetitionService) {}
}
